module.exports = __webpack_public_path__ + "assets/img/delete1.8f3ddf5f.svg";